import { Suspense, lazy, useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { connect } from "react-redux";
import Loadable from "react-loadable";

// Images
import { images } from "../../imageValues";
import Button from "../../component/Button/Button";

// Custom Styled
import {
  AppButton,
  ButtonArea,
  ButtonImg,
  CenterArea,
  Container,
  DivButtons,
  MatchBoxStrip,
  MatchBoxStripArea,
  MatchBoxStripButton,
  ModalButton,
  OuterDiv,
  PlayGround,
} from "./HomeStyle";

// Pages
import Begin from "../Begin/Begin";
import Tutorial from "../Tutorial/Tutorial";
import Game from "../Game/Game";
import SelectBoard from "../SelectBoard/SelectBoard";
import FiddleOne from "../FiddleOne/FiddleOne";

//Custom
import { AxlTracker, playSound, randomArtImage } from "../../utils";

// Actions
import { playPauseSound } from "../../actions/playPauseSoundAction";
import { changeLanguage } from "../../actions/changeLanguageAction";
import Information from "../Information/Information";
import Instruction from "../Instruction/Instruction";

//AXL
import { useAxL } from "../../AxLContext";
import AxL from "../../axl";
import Test from "../test";
import { randomArtworkReset } from "../../actions/randomArtworkAction";
import stringValues from "../../stringValues";

const Home = (props) => {
  const axl = useAxL();
  const {
    playPauseSound,
    playPauseSoundState,
    changeLanguage,
    changeLanguageState,
    randomArtworkState,
    boardName,
    randomArtworkReset,
  } = props;
  const [mobileWidth, setMobileWidth] = useState(window.innerWidth);
  const [page, setPage] = useState(1);
  const [boardType, setBoardType] = useState("");
  const [showReset, setShowReset] = useState(false);
  const [showButtons, setShowButtons] = useState(true);
  const [updateInfo, setUpdateInfo] = useState(false);
  const [updateInstruction, setUpdateInstruction] = useState(false);
  const [random, setRandom] = useState();
  const [showAnimation, setShowAnimation] = useState(false);
  const [showDropDownLanguage, SetshowDropDownLanguage] = useState(false);
  const isMobileView = mobileWidth > 1080;
  const [componentToLoad, setComponentToLoad] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setMobileWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (randomArtworkState.data !== null) {
      const data = randomArtImage(randomArtworkState.data, boardType);
      setRandom(data.HD);
    }
  }, [randomArtworkState]);

  //This is used to reload the game from start
  useEffect(() => {
    if (showReset === true) {
      setTimeout(() => {
        setShowReset(false);
        window.location.reload();
      }, 1000);
    }
  }, [showReset]);

  // This is used to set page number
  const onChange = () => {
    setPage(page + 1);
  };

  // This is used to donwload image
  const onDownload = () => {
    saveAs(random, "artwork");
  };

  // This is used to get board type selected by user
  const onSelectBoard = (value) => {
    setBoardType(value);
    onChange();
  };

  // // This is used to set animation off
  // useEffect(() => {
  //   if (page === 2 && componentToLoad === true) {
  //     const timer = setTimeout(() => {
  //       setShowAnimation(false);
  //     }, 6000);
  //     return () => {
  //       clearTimeout(timer);
  //     };
  //   }
  // }, [componentToLoad]);

  const info = () => {
    setUpdateInfo(!updateInfo);
  };

  const instruction = () => {
    setUpdateInstruction(!updateInstruction);
  };

  const AxlShare = () => {
    axl.sendMessage(AxL.ChildToHost.SHARE, {
      title:
        "Build your own matchbox art collection with @harshitrnnh with @MAPBangalore, @TasveerGhar #IndianMatchboxes #MatchboxMomentos #MatchboxArt",
    });
  };

  const switchLanguage = () => {
    return changeLanguageState.data === "en"
      ? changeLanguage("hi")
      : changeLanguage("en");
  };

  const resetAll = () => {
    setPage(1);
    setShowAnimation(false);
    setRandom();
    setComponentToLoad(false);
    randomArtworkReset();
  };

  return (
    <Container>
      {showButtons && mobileWidth > 1080 ? (
        <ButtonArea>
          {(!updateInfo && !updateInstruction) ||
          (page === 1 && !updateInfo) ? (
            <AppButton
              onClick={() => {
                info();
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Information",
                  "Hide and Unhide",
                  3,
                  true
                );
              }}
              title="Info"
            >
              <img src={images.INFORMATION} />
            </AppButton>
          ) : (
            <></>
          )}
          <>
            <AppButton
              onClick={() => {
                // SetshowDropDownLanguage(!showDropDownLanguage);
                switchLanguage();
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Language",
                  "Language Switch",
                  4,
                  true
                );
              }}
              title="Language"
            >
              <img src={images.LANGUAGE} />
            </AppButton>
            <AppButton
              onClick={() => {
                playPauseSound(!playPauseSoundState.data);
                playSound(playPauseSoundState);
                AxlTracker(
                  axl,
                  "Clicked on Volume",
                  "Mute and Unmute",
                  5,
                  true
                );
              }}
              title={stringValues[changeLanguageState.data].sound}
            >
              {playPauseSoundState.data ? (
                <img src={images.VOLUMEON} />
              ) : (
                <img src={images.VOLUMEOOF} />
              )}
            </AppButton>
            <AppButton
              onClick={() => {
                AxlShare();
                AxlTracker(axl, "Clicked on Share", "Share", 66, true);
              }}
              title={stringValues[changeLanguageState.data].share}
            >
              <img src={images.SHAREBUTTON} />
            </AppButton>
          </>

          {(page === 4 || page === 3) && !updateInfo && !updateInstruction && (
            <>
              <AppButton
                onClick={() => {
                  instruction();
                  playSound(playPauseSoundState);
                  AxlTracker(
                    axl,
                    "Clicked on Instruction",
                    "Hide and Unhide",
                    6,
                    true
                  );
                }}
                title={stringValues[changeLanguageState.data].instruction}
              >
                <img src={images.INSTRUCTION} />
              </AppButton>
              <AppButton
                onClick={() => {
                  playSound(playPauseSoundState);
                  AxlTracker(
                    axl,
                    "Clicked on Restart",
                    "Game Restart",
                    7,
                    true
                  );
                  resetAll();
                }}
                title={stringValues[changeLanguageState.data].restart}
              >
                <img src={images.RESTART} />
              </AppButton>
            </>
          )}
        </ButtonArea>
      ) : (
        <></>
      )}
      {page === 2 ? (
        showAnimation ? (
          <div style={{ width: 380 }}>
            <Suspense
              fallback={<Test getState={() => setComponentToLoad(true)} />}
            ></Suspense>
          </div>
        ) : (
          <>
            {mobileWidth < 1080 && (
              <OuterDiv>
                <DivButtons
                  onClick={() => {
                    info();
                    playSound(playPauseSoundState);
                    AxlTracker(
                      axl,
                      "Clicked on Information",
                      "Hide and Unhide",
                      10,
                      true
                    );
                  }}
                  title="Information"
                >
                  <ButtonImg src={images.INFORMATION} />
                </DivButtons>
                <DivButtons
                  onClick={() => {
                    // SetshowDropDownLanguage(!showDropDownLanguage); // For three language required later
                    switchLanguage();
                    playSound(playPauseSoundState);
                    AxlTracker(
                      axl,
                      "Clicked on Language",
                      "Language Switch",
                      9,
                      true
                    );
                  }}
                  title="Language"
                >
                  <ButtonImg src={images.LANGUAGE} />
                </DivButtons>
                <DivButtons
                  onClick={() => {
                    AxlShare();
                    playSound(playPauseSoundState);
                    AxlTracker(axl, "Clicked on Share", "Share", 97, true);
                  }}
                  title="Share"
                >
                  <ButtonImg src={images.SHAREBUTTON} />
                </DivButtons>
                <DivButtons
                  onClick={() => {
                    playPauseSound(!playPauseSoundState.data);
                    playSound(playPauseSoundState);
                    AxlTracker(
                      axl,
                      "Clicked on Volume",
                      "Mute and Unmute",
                      11,
                      true
                    );
                  }}
                  title="Sound"
                >
                  {playPauseSoundState.data ? (
                    <ButtonImg src={images.VOLUMEON} />
                  ) : (
                    <ButtonImg src={images.VOLUMEOOF} />
                  )}
                </DivButtons>
              </OuterDiv>
            )}

            {!updateInfo && <Tutorial onClick={onChange} />}
          </>
        )
      ) : page === 3 ? (
        <>
          {!updateInfo && !updateInstruction ? (
            <>
              <SelectBoard
                onClick={(value) => onSelectBoard(value)}
                getInfo={(checkInfo) => setUpdateInfo(checkInfo)}
                setInfo={updateInfo}
                getInstruction={(checkInstruction) =>
                  setUpdateInstruction(checkInstruction)
                }
                setInstruction={updateInstruction}
                resetGame={() => setPage(1)}
              />
              {/* {showDropDownLanguage && DropdownLanguageView()} */}
            </>
          ) : (
            <></>
          )}
        </>
      ) : page === 4 ? (
        // !updateInfo && (
        <>
          <Game
            boardName={boardType}
            onGameComplete={resetAll}
            getInfo={(checkInfo) => setUpdateInfo(checkInfo)}
            setInfo={updateInfo}
            getInstruction={(checkInstruction) =>
              setUpdateInstruction(checkInstruction)
            }
            setInstruction={updateInstruction}
            showButton={(e) => setShowButtons(e)}
          />
        </>
      ) : // )
      page === 5 ? (
        <>
          <FiddleOne
            onClick={() => {
              console.log("asdnks");
              playSound(playPauseSoundState);
              onChange();
              AxlTracker(
                axl,
                "Clicked on Continue Collecting",
                "Continue Collecting",
                18,
                true
              );
            }}
            boardName={boardType}
            onDownload={onDownload}
          />
        </>
      ) : !updateInfo ? (
        <>
          <PlayGround>
            {mobileWidth < 1080 && (
              <OuterDiv>
                <DivButtons
                  onClick={() => {
                    info();
                    playSound(playPauseSoundState);
                    AxlTracker(
                      axl,
                      "Clicked on Information",
                      "Hide and Unhide",
                      10,
                      true
                    );
                  }}
                  title="Information"
                >
                  <ButtonImg src={images.INFORMATION} />
                </DivButtons>
                <DivButtons
                  onClick={() => {
                    // SetshowDropDownLanguage(!showDropDownLanguage); // For three language required later
                    switchLanguage();
                    playSound(playPauseSoundState);
                    AxlTracker(
                      axl,
                      "Clicked on Language",
                      "Language Switch",
                      9,
                      true
                    );
                  }}
                  title="Language"
                >
                  <ButtonImg src={images.LANGUAGE} />
                </DivButtons>
                <DivButtons
                  onClick={() => {
                    AxlShare();
                    playSound(playPauseSoundState);
                    AxlTracker(axl, "Clicked on Share", "Share", 97, true);
                  }}
                  title="Share"
                >
                  <ButtonImg src={images.SHAREBUTTON} />
                </DivButtons>
                <DivButtons
                  onClick={() => {
                    playPauseSound(!playPauseSoundState.data);
                    playSound(playPauseSoundState);
                    AxlTracker(
                      axl,
                      "Clicked on Volume",
                      "Mute and Unmute",
                      11,
                      true
                    );
                  }}
                  title="Sound"
                >
                  {playPauseSoundState.data ? (
                    <ButtonImg src={images.VOLUMEON} />
                  ) : (
                    <ButtonImg src={images.VOLUMEOOF} />
                  )}
                </DivButtons>
              </OuterDiv>
            )}
            {mobileWidth > 1080 ? (
              <MatchBoxStrip src={images.MATCHBOXSTRIP} />
            ) : (
              // <MatchBoxStripArea>
              //   <MatchBoxStrip src={images.MATCHBOXSTRIPINFO} />
              //   <MatchBoxStripButton
              //     onClick={() => {
              //       info();
              //       playSound(playPauseSoundState);
              //       AxlTracker(
              //         axl,
              //         "Clicked on Information",
              //         "Hide and Unhide",
              //         10,
              //         true
              //       );
              //     }}
              //     style={{
              //       left: 17,
              //     }}
              //     title="Info"
              //   />
              // </MatchBoxStripArea>
              <MatchBoxStrip src={images.MATCHBOXSTRIP} />
            )}
            <CenterArea
              style={{ position: isMobileView ? "unset" : "relative" }}
            >
              <Begin onChange={onChange} />
            </CenterArea>
            {mobileWidth > 1080 ? (
              <MatchBoxStrip src={images.MATCHBOXSTRIP} />
            ) : (
              // <MatchBoxStripArea>
              //   <MatchBoxStrip
              //     src={
              //       playPauseSoundState.data
              //         ? images.MATCHBOXSTRIPAUDIOONSHARELANGUAGE
              //         : images.MATCHBOXSTRIPAUDIOOFFSHARELANGUAGE
              //     }
              //   />
              //   <MatchBoxStripButton
              //     onClick={() => {
              //       // SetshowDropDownLanguage(!showDropDownLanguage); // For three language required later
              //       switchLanguage();
              //       playSound(playPauseSoundState);
              //       AxlTracker(
              //         axl,
              //         "Clicked on Language",
              //         "Language Switch",
              //         9,
              //         true
              //       );
              //     }}
              //     style={{
              //       left: 14,
              //     }}
              //     title={stringValues[changeLanguageState.data].language}
              //   />
              //   <MatchBoxStripButton
              //     onClick={() => {
              //       AxlShare();
              //       playSound(playPauseSoundState);
              //       AxlTracker(axl, "Clicked on Share", "Share", 97, true);
              //     }}
              //     style={{
              //       right: 174,
              //     }}
              //     title={stringValues[changeLanguageState.data].share}
              //   />
              //   <MatchBoxStripButton
              //     onClick={() => {
              //       playPauseSound(!playPauseSoundState.data);
              //       playSound(playPauseSoundState);
              //       AxlTracker(
              //         axl,
              //         "Clicked on Volume",
              //         "Mute and Unmute",
              //         11,
              //         true
              //       );
              //     }}
              //     style={{
              //       marginRight: 15,
              //     }}
              //     title={stringValues[changeLanguageState.data].sound}
              //   />
              // </MatchBoxStripArea>
              <MatchBoxStrip src={images.MATCHBOXSTRIP} />
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              {page !== 1 ? (
                <Button
                  label={stringValues[changeLanguageState.data].startCollecting}
                  onClick={() => {
                    onChange();
                    playSound(playPauseSoundState);
                  }}
                />
              ) : (
                <></>
              )}
            </div>
          </PlayGround>
        </>
      ) : (
        <></>
      )}
      {updateInfo === true && (
        <>
          <Information
            onClick={() => {
              setUpdateInfo(false);
              playSound(playPauseSoundState);
              AxlTracker(
                axl,
                "Clicked on Information",
                "Hide and Unhide",
                3,
                true
              );
            }}
            changeLanguage={() => {
              // SetshowDropDownLanguage(!showDropDownLanguage);
              switchLanguage();
              playSound(playPauseSoundState);
              AxlTracker(
                axl,
                "Clicked on Language",
                "Language Switch",
                4,
                true
              );
            }}
            playPauseSound={() => {
              playPauseSound(!playPauseSoundState.data);
              playSound(playPauseSoundState);
              AxlTracker(axl, "Clicked on Volume", "Mute and Unmute", 11, true);
            }}
            onClickShare={() => {
              AxlShare();
              playSound(playPauseSoundState);
              AxlTracker(axl, "Clicked on Share", "Share", 66, true);
            }}
          />
        </>
      )}

      {(page === 3 || page === 5) && updateInstruction === true && (
        <Instruction
          onClick={() => {
            AxlTracker(
              axl,
              "Clicked on Instruction",
              "Hide and Unhide",
              6,
              true
            );
            setUpdateInstruction(false);
            playSound(playPauseSoundState);
          }}
          changeLanguage={() => {
            console.log('Hiii');
            // SetshowDropDownLanguage(!showDropDownLanguage);
            switchLanguage();
            playSound(playPauseSoundState);
            AxlTracker(axl, "Clicked on Language", "Language Switch", 4, true);
          }}
          playPauseSound={() => {
            playPauseSound(!playPauseSoundState.data);
            playSound(playPauseSoundState);
            AxlTracker(axl, "Clicked on Volume", "Mute and Unmute", 11, true);
          }}
          onClickShare={() => {
            AxlShare();
            playSound(playPauseSoundState);
            AxlTracker(axl, "Clicked on Share", "Share", 66, true);
          }}
        />
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  playPauseSoundState: state.playPauseSound,
  changeLanguageState: state.changeLanguage,
  randomArtworkState: state.randomArtwork,
});

const mapDispatchToProps = (dispatch) => ({
  playPauseSound: (params) => dispatch(playPauseSound(params)),
  changeLanguage: (params) => dispatch(changeLanguage(params)),
  randomArtworkReset: () => dispatch(randomArtworkReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
